import React from "react";

function ActiveSlideLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
    >
      <circle cx="15.5836" cy="15.3168" r="14.982" fill="#7950FF" />
      <path
        d="M14.0668 11.9174C14.0668 11.3386 14.4814 10.8798 15.2829 10.8798C16.1467 10.8798 16.6788 11.4515 16.6788 12.4962H22.2137C22.2137 8.1199 18.2957 7.08936 15.3866 7.08936C11.5308 7.08936 8.65625 8.87516 8.65625 11.6845C8.65625 17.8465 16.9897 15.7925 16.9897 18.5595C16.9897 19.3218 16.3471 19.6888 15.5455 19.6888C14.129 19.6888 13.9977 18.623 13.9977 18.1853H8.66316C8.66316 22.2087 12.1389 23.5498 15.5662 23.5498C20.0508 23.5498 22.5177 21.8981 22.5177 18.6583C22.5108 13.202 14.0668 14.9596 14.0668 11.9174Z"
        fill="#ECE6FF"
      />
    </svg>
  );
}

export default ActiveSlideLogo;
